import { render, staticRenderFns } from "./FaturamentoGrupoProdutosClassificacaoVendas.vue?vue&type=template&id=18421e15&scoped=true&"
import script from "./FaturamentoGrupoProdutosClassificacaoVendas.vue?vue&type=script&lang=js&"
export * from "./FaturamentoGrupoProdutosClassificacaoVendas.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoGrupoProdutosClassificacaoVendas.vue?vue&type=style&index=0&id=18421e15&scoped=true&lang=css&"
import style1 from "./FaturamentoGrupoProdutosClassificacaoVendas.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18421e15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
